var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2852 14.4287C20.2852 12.4563 18.6863 10.8574 16.7139 10.8574C14.7414 10.8574 13.1426 12.4563 13.1426 14.4287C13.1426 16.4012 14.7414 18 16.7139 18V19.4287C13.9524 19.4287 11.7139 17.1901 11.7139 14.4287C11.7139 11.6673 13.9524 9.42871 16.7139 9.42871C19.4753 9.42871 21.7139 11.6673 21.7139 14.4287C21.7139 17.1901 19.4753 19.4287 16.7139 19.4287V18C18.6863 18 20.2852 16.4012 20.2852 14.4287Z",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4287 26.5713C22.4285 25.8273 21.9811 24.5545 21.0742 23.4551C20.1831 22.375 18.9396 21.5713 17.4287 21.5713C15.3761 21.5713 14.0836 22.4127 13.2304 23.4531C12.3539 24.5221 11.9222 25.8297 11.6933 26.7451C11.5976 27.1277 11.2097 27.3601 10.8271 27.2646C10.4444 27.169 10.211 26.7811 10.3066 26.3984C10.5539 25.4093 11.0504 23.8597 12.1259 22.5479C13.2251 21.2074 14.9098 20.1436 17.4287 20.1436C19.489 20.1436 21.1026 21.2451 22.1757 22.5459C23.2327 23.827 23.8572 25.4106 23.8574 26.5713C23.8574 26.9658 23.537 27.2861 23.1425 27.2861C22.7482 27.286 22.4287 26.9657 22.4287 26.5713Z",
    fill: "#3F3F3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5707 26.5717C25.5706 23.922 24.2434 22.0638 23.1088 21.4965C22.7559 21.3201 22.613 20.8913 22.7895 20.5385C22.9659 20.1856 23.3946 20.0427 23.7475 20.2191C25.4698 21.0803 26.9993 23.5075 26.9994 26.5717C26.9994 26.9661 26.6799 27.2864 26.2855 27.2865C25.8911 27.2865 25.5707 26.9662 25.5707 26.5717Z",
    fill: "#3F3F3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1092 10.2191C23.462 10.0428 23.8908 10.1856 24.0672 10.5384C24.8095 12.023 25.6251 14.3833 24.8201 16.7982C24.6383 17.3436 24.2832 17.9912 23.867 18.5658C23.4556 19.1336 22.9286 19.7083 22.365 20.0433C22.0259 20.2449 21.5871 20.1334 21.3855 19.7943C21.184 19.4552 21.2955 19.0164 21.6346 18.8148C21.9562 18.6236 22.3484 18.2281 22.7107 17.7279C23.0682 17.2344 23.3413 16.7161 23.4646 16.346C24.0882 14.4752 23.4761 12.5496 22.7898 11.1771C22.6134 10.8243 22.7563 10.3955 23.1092 10.2191Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/peopleIcon.e0f592f9740500336c531d38b157083b.svg";
export { ForwardRef as ReactComponent };